import React from 'react'

import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import CampaignNavbar from '../CampaignNavBar/CampaignNavBar'
import AffiliateComparisonReport from '../../Reports/AffiliateComparisonReport/AffiliateComparisonReport'

const CampaignAffiliateComparisonReport = ({ showSystemMessage }) => {

    const location = useLocation()
    let urlParams = queryString.parse(location.search)

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Reports</h1>
                <div className="ml-5">
                    <CampaignNavbar campaignId={urlParams.campaignId} showSystemMessage={showSystemMessage} />
                </div>
            </div>
            <AffiliateComparisonReport campaignId={urlParams.campaignId} showSystemMessage={showSystemMessage} />
        </div>
    )
}

export default CampaignAffiliateComparisonReport
